import { UtilityType } from '../../interfaces/GenericInterfaces';

export class UtilityDTO {
  public id?: number;
  public type: UtilityType;
  public thumbnailUrl: string;

  constructor(type: UtilityType, thumbnailUrl: string, id?: number) {
    this.id = id;
    this.type = type;
    this.thumbnailUrl = thumbnailUrl;
  }
}
